/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Key_UsdaInputs */

const en_ai_key_usda = /** @type {(inputs: Ai_Key_UsdaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USDA API key`)
};

const de_ai_key_usda = /** @type {(inputs: Ai_Key_UsdaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USDA-API-Schlüssel`)
};

/**
* | output |
* | --- |
* | "USDA API key" |
*
* @param {Ai_Key_UsdaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_key_usda = /** @type {((inputs?: Ai_Key_UsdaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Key_UsdaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_key_usda(inputs)
	return en_ai_key_usda(inputs)
});